import {Heading} from '@primer/react'

import styles from './Title.module.css'
import {clsx} from 'clsx'

export type TitleProps = React.HTMLAttributes<HTMLElement> & {
  children: React.ReactNode | string
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  className?: string
}

const Title = ({children, as = 'h3', className, ...restProps}: TitleProps) => {
  return (
    <Heading {...restProps} as={as} className={clsx(styles.Heading, className)}>
      {children}
    </Heading>
  )
}
Title.displayName = 'ControlGroup.Title'

export default Title
